( function ( $ ) {

  const base = {
    rows: 0,
    dots: false,
    arrows: true,
    slidesToShow: 1,
    waitForAnimate: false,
    speed: 300,
    cssEase: 'ease',
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: ThemeJS.Variables.Screen_Sizes.md,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: ThemeJS.Variables.Screen_Sizes.lg,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: ThemeJS.Variables.Screen_Sizes.xl,
        settings: {
          slidesToShow: 4,
        }
      },
    ]
  }

  function init ( $slider, args ) {
    if ( !$slider.hasClass('slick-initialized') ) {
      $slider.slick( args )
    }
  }

  function set_last_active ( $slider ) {
    $( '.step', $slider ).removeClass( 'last-active' ).filter( '.slick-active' ).last().addClass( 'last-active' )
  }

  $( 'section.process-slider' ).each( function () {
    const $section = $(this)
    const $slider = $( '.steps', this )
    const $prev = $( '.prev-btn', $section )
    const $next = $( '.next-btn', $section )

    const num_slides = $( '.step', $section ).length
    const max_per_page = Math.min( num_slides, $section.data('max-per-page') )

    const args = $.extend( base, {
      prevArrow: $prev,
      nextArrow: $next,
    })

    args.responsive = args.responsive.map( bp => {
      bp.settings.slidesToShow = Math.min( bp.settings.slidesToShow, max_per_page )
      bp.settings = ( bp.settings.slidesToShow >= num_slides ) ? 'unslick' : bp.settings
      return bp
    })

    $slider.on( 'mousedown touchstart', () => $slider.addClass( 'dragging' ) )
    $slider.on( 'mouseup mouseleave touchend touchcancel', () => $slider.removeClass( 'dragging' ) )

    $slider.on( 'beforeChange', () => $slider.addClass( 'changing' ) )
    $slider.on( 'afterChange', () => $slider.removeClass( 'changing' ) )

    $slider.on( 'init afterChange breakpoint', () => set_last_active( $slider ) )

    init( $slider, args )
    $( window ).on( 'breakpoint_changed', () => init( $slider, args ) )
  })

})( jQuery );